import script from "./CarouselThree.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselThree.vue?vue&type=script&setup=true&lang=js"

import "./CarouselThree.vue?vue&type=style&index=0&id=b84e37f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b84e37f0"]])

export default __exports__